module.exports = __webpack_public_path__ + "img/title2.d9ead00c.png";